import * as clientLegalForms from 'constants/enums/clientLegalForms'

export default {
  [clientLegalForms.NATURAL_PERSON]: 'Fyzická osoba',
  [clientLegalForms.LEGAL_ENTITY]: 'Právnická osoba',
}
